// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TimerPlayer_wrapper__3DBzX"};